import sdl from '@jds/react-generated-sdl/JDSInputField';
import type { JDSInputFieldProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, InputFieldProps } from '../logic';

const Component = (props: InputFieldProps) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    disabled = false,
    state = 'undefined',
    type = 'undefined',
    ariaLabel = props.label?.toString(),
    _ariaplaceholder = props.placeholder?.toString(),
    _ariaRequired = props.required?.toString(),
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      disabled,
      state,
      type,
      ariaLabel,
      _ariaplaceholder,
      _ariaRequired,
      ...rest
    },
    'JDSInputField',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const InputField = withLogic(Component) as React.ForwardRefExoticComponent<
  InputFieldProps & React.RefAttributes<HTMLInputElement>
> & { slotName?: string };

InputField.displayName = 'InputField';
InputField.slotName = 'jds_input_field';

export { InputField, type JDSInputFieldProps };
